import React, { useCallback } from 'react';
import { Orderlist } from '../../../../models/OrderList';
import { NewSelectionListDropdown } from '../NewSelectionListDropdown';
import { ListManager } from '../../components/ListManager';
import { ButtonSize, ButtonTheme } from '../Button';

import './TargetSelectionListDropdown.scss';
import { useTarget } from '../useTarget';

/**
 * Props for <TargetSelectionListDropdown>.
 */
interface TargetSelectionListDropdownProps {
    readonly size?: ButtonSize;
    readonly theme?: ButtonTheme;

    /**
     * All available selection lists.
     */
    readonly orderlists: ReadonlyArray<Orderlist>;

    /**
     * ID of the currently selected selection list.
     */
    readonly selectedOrderlist: Orderlist | undefined;

    /**
     * Callback for creating a new selection list.
     */
    readonly onCreate: (string) => void;
}

export function TargetSelectionListDropdown({
    size,
    theme,
    orderlists,
    selectedOrderlist: activeOrderlist,
    onCreate
}: TargetSelectionListDropdownProps) {
    const hasOrderlists = orderlists.length > 0;
    const { setTargetSelectionList } = useTarget();

    const onListClick = useCallback(
        (listId: string) => {
            const orderlist = orderlists.find(list => list.id === listId);
            if (orderlist) {
                setTargetSelectionList(orderlist);
            }
        },
        [setTargetSelectionList, orderlists]
    );

    if (!hasOrderlists) {
        return <NewSelectionListDropdown onCreateSelectionList={onCreate} />;
    }

    return (
        <ListManager
            size={size}
            theme={theme}
            label={activeOrderlist?.listName}
            options={orderlists}
            onSelect={onListClick}
            onCreate={onCreate}
            disabled={false}
        />
    );
}
